import React from 'react';
import styles from './CheckboxV2.module.scss';

export type CheckboxProps = {
	id?: string;
	className?: string;
	label?: string;
	required?: boolean;
	checked?: boolean;
	onChange?: (arg: any) => void;
	name?: string;
	disabled?: boolean;
	value?: any;
	rbf?: string;
	error?: boolean;
};

const InnerComponent = (
	{ id, className, label, required, checked, rbf, disabled, error, onChange, ...props }: CheckboxProps,
	ref: React.ForwardedRef<HTMLInputElement>,
): React.JSX.Element => {
	const isError = (required && !checked) || error;

	const containerClassName = [styles.container, className, disabled && styles.disabled, isError && styles.error]
		.filter(Boolean)
		.join(' ');

	return (
		<label
			htmlFor={id}
			className={containerClassName}
			data-test-id={`checkbox${id ? '-' + id : ''}`}
			data-rbf={rbf || `checkbox${id ? '-' + id : ''}`}
		>
			<input
				id={id}
				ref={ref}
				type="checkbox"
				data-test-id={`checkbox-input${id ? '-' + id : ''}`}
				checked={checked}
				disabled={disabled}
				onChange={onChange}
				{...props}
			/>
			<div className={styles.checkbox}>
				<span className={styles.checkmark} />
			</div>
			{label && (
				<span data-test-id="label">
					{label}
					{required && '*'}
				</span>
			)}
		</label>
	);
};

const CheckboxV2 = React.forwardRef(InnerComponent);
export default CheckboxV2;
